// extracted by mini-css-extract-plugin
export default {"items":"styles_items__ZhGVA","noProductsFound":"styles_noProductsFound__hj9Oy"};